import React, { useState } from "react";
import KickImage from 'Reuseables/KickImage';
import { Col } from "react-bootstrap"

/* UTILS or HELPERS */
import { getCloudImageUrl } from "../../../utils"

/* COMPONENTS */
import { ShippingNReturnPolicy } from "../../Modals/StaticInfoModal/ModalStaticInfo";

/* ASSETS */
import BackArrow from "../../../images/shopping-cart-back.png";
import ContinueArrow from "../../../images/shopping-cart-continue.png";

const BackArrowIcon: any = BackArrow
const ContinueArrowIcon: any = ContinueArrow

interface paymentMethod {
  type: string;
  logo: string;
  label: string;
  active: boolean;
  payment_group: number;
  payment_method: string;
}

type OtherPaymentsConfirmationProcessProps = {
  amountToBePaid: string
  isSubmit: boolean
  currentPaymentMethod: paymentMethod
  handleSubmit: () => void
  setMakeOfferProcess: (args: string) => void
  setCurrentPaymentMethod: (args: Object) => void
}

const OtherPaymentsConfirmationProcess: React.FC<OtherPaymentsConfirmationProcessProps> = ({
  amountToBePaid,
  isSubmit,
  currentPaymentMethod,
  handleSubmit,
  setMakeOfferProcess,
  setCurrentPaymentMethod
}): JSX.Element => {
  const [openShippingPolicyInfo, setOpenShippingPolicyInfo] = useState(false)
  const type = currentPaymentMethod?.type.split("_").join(" ")
  return (
    <Col className="confirm-others-kick-credit">
      <div className="confirm-other-content-wrapper">
        <div className="amount-to-be-paid">
          <p>Amount to be paid</p>
          <p>IDR {amountToBePaid}</p>
        </div>
        <div className="others-kick-credit-card-container">
          <p>Payment method</p>
          <div className={`payment-method-card ${currentPaymentMethod.logo ? "" : "no-img"}`}>
            {currentPaymentMethod?.logo ? <KickImage
              src={getCloudImageUrl(currentPaymentMethod.logo)}
              alt="..."
            /> : null}
            <div className={`payment-method-currency ${currentPaymentMethod.logo ? "" : "no-img"}`}>
              <p>{type}{type === "bank transfer" ? " - Manual Verification" : ""}</p>
              <p>{currentPaymentMethod.label}</p>
            </div>
          </div>
          {type === "bank transfer" ?
            <p className="bank-transfer-info">You will need to submit prove to payment to confirm your purchase</p>
            : null
          }
        </div>
      </div>
      <div className="confirm-other-payment-button">
        <p>By clicking Proceed to payment, you have agreed on our <u onClick={() => setOpenShippingPolicyInfo(!openShippingPolicyInfo)}>Shipping and Returns Policy</u> and our Terms and Conditions.
          {`${currentPaymentMethod.type !== "bank_transfer" ? "You will be redirected to payment page provided by a secured 3rd party." : ""}`}
        </p>
        <div
          onClick={() => {
            if (isSubmit) return null
            setMakeOfferProcess("choose-payment");
            setCurrentPaymentMethod({});
          }}
          id="button-19"
          className={`button ${isSubmit ? "disabled" : ""}`}
        >
          <KickImage src={BackArrowIcon} alt="..." />
          <p>Back</p>
        </div>
        <div id="button-20" className={`button ${isSubmit ? "disabled" : ""}`} onClick={() => !isSubmit && handleSubmit()}>
          <p>Continue</p>
          <KickImage src={ContinueArrowIcon} alt="..." />
        </div>
      </div>
      <ShippingNReturnPolicy isOpen={openShippingPolicyInfo} onToggle={() => setOpenShippingPolicyInfo(!openShippingPolicyInfo)} />
    </Col>
  )
}

export default OtherPaymentsConfirmationProcess